import { EnglishDictionary } from './en';

const nl: EnglishDictionary = {
  login: {
    title: 'Welkom',
    email: 'E-mail',
    password: 'Wachtwoord',
    confirmPassword: 'Wachtwoord bevestigen',
    forgotPassword: 'Wachtwoord vergeten?',
    submit: 'Inloggen',
    noAccount: 'Nog geen account?',
    signUp: 'Registreren',
    intro: 'Inloggen bij uw account',
    success: 'Inloggen succesvol',
    error: 'Fout bij inloggen',
    missingCredentials: 'Voer een geldig e-mailadres en wachtwoord in.',
    blocked: 'Je account is tijdelijk geblokkeerd.',
  },
  changePassword: {
    title: 'Wachtwoord wijzigen',
    intro:
      'Bevestig het e-mailadres van je account en je ontvangt een eenmalige code om je wachtwoord opnieuw in te stellen.',
    email: 'E-mail',
    login: 'Inloggen',
    oneTimeCode: 'Eenmalige code',
    confirmPassword: 'Wachtwoord bevestigen',
    newPassword: 'Nieuw wachtwoord',
    minPassword: 'Wachtwoord moet minimaal 6 tekens bevatten',
    enterOTP: 'Voer de OTP-code in die naar uw e-mail is verzonden.',
    verifyOTP: 'OTP verifiëren',
    sentOTP: 'OTP verzonden naar uw e-mail',
    errorSendingOTP:
      'De e-mail met de eenmalige code kon niet worden verzonden. Probeer het opnieuw of neem contact op met support.',
    invalidOTP: 'Ongeldige OTP',
    verifiedOTP: 'OTP succesvol geverifieerd',
    passwordChanged: 'Wachtwoord succesvol gewijzigd',
    errorChangingPassword: 'Fout bij het wijzigen van wachtwoord',
    buttonText: 'Wachtwoord wijzigen',
    errorNoUser: 'Er is geen gebruiker gekoppeld aan het e-mailadres {email}.',
  },
  logout: {
    success: 'U bent succesvol uitgelogd.',
    error: 'Er is een fout opgetreden bij het uitloggen.',
  },
  resetPassword: {
    title: 'Wachtwoord resetten',
    email: 'E-mail',
    submit: 'Link versturen',
    backToLogin: 'Terug naar inloggen',
    success: 'Wachtwoord reset e-mail verstuurd',
    newPassword: 'Nieuw wachtwoord',
    confirmPassword: 'Nieuw wachtwoord bevestigen',
    changePassword: 'Wachtwoord wijzigen',
  },
  validation: {
    required: 'Dit veld is verplicht',
    invalidEmail: 'Ongeldig e-mailadres',
    passwordMismatch: 'Wachtwoorden komen niet overeen',
    passwordTooShort: 'Wachtwoord moet minimaal 8 tekens bevatten',
  },
  fields: {
    fullName: 'Volledige naam',
    email: 'E-mail',
    phone: 'Telefoon',
    password: 'Wachtwoord',
    confirmPassword: 'Wachtwoord bevestigen',
    doctor: 'Arts',
    indications: 'Indicaties',
    notes: 'Notities',
    id: 'ID',
    patientId: 'Patiënt-ID',
    dateOfBirth: 'Geboortedatum',
    gender: 'Geslacht',
    created: 'Datum Toegevoegd',
    createdAt: 'Aangemaakt op',
    updatedAt: 'Bijgewerkt op',
    createdBy: 'Aangemaakt door',
    male: 'Mannelijk',
    female: 'Vrouwelijk',
    other: 'Anders',
    fileSize: 'Bestandsgrootte',
    revisionHistory: 'Revisiegeschiedenis',
    exportStatus: 'Exportstatus',
  },
  patientsPage: {
    title: 'Patiënten',
    description: 'Beheer uw patiënten',
    newPatient: 'Nieuwe Patiënt',
    instructions: `##### **Wie voegt u toe?**
Vul de velden in om een patiëntprofiel aan te maken.
##### **Tips:**
- geeft een verplicht veld aan
- Het invullen van het optionele veld kan later handig zijn
- Alle patiëntgegevens worden anoniem opgeslagen`,
  },
  addPatientPage: {
    title: 'Patiënt Toevoegen',
    description: 'Voeg een nieuwe patiënt toe aan het systeem',
    success: 'Patiënt succesvol toegevoegd',
    error: 'Fout bij het toevoegen van patiënt',
    submitText: 'Patiënt Toevoegen',
  },
  sections: {
    generalPatientInformation: 'Algemene Patiëntinformatie',
    medicalInformation: 'Medische Informatie',
    orderInformation: 'Bestelinformatie',
  },
  placeholders: {
    fullName: 'Voer volledige naam in',
    email: 'Voer e-mailadres in',
    phone: 'Voer telefoonnummer in',
    doctor: 'Voer artsinformatie in',
    indications: 'Voer indicatiesinformatie in',
    notes: 'Voer notities in',
    patientId: 'Voer patiënt-ID in',
    dateOfBirth: 'Voer geboortedatum in',
    gender: 'Voer geslacht in',
    password: 'Voer wachtwoord in',
    confirmPassword: 'Bevestig uw wachtwoord',
    companyName: 'Voer bedrijfsnaam in',
    clientId: 'Voer klant-ID in',
    line1: 'Voer adresregel 1 in',
    city: 'Voer stad in',
    postalCode: 'Voer postcode in',
    country: 'Voer land in',
    state: 'Voer provincie in',
  },
  onUpdate: {
    title: 'Patiënt Bijwerken',
    success: 'Patiënt succesvol bijgewerkt',
    error: 'Fout bij het bijwerken van patiënt',
  },
  onUpdateOrder: {
    title: 'Bestelling bijwerken',
    success: 'Bestelling succesvol bijgewerkt',
    error: 'Fout bij het bijwerken van de bestelling',
  },
  onDelete: {
    title: 'Patiënt Verwijderen',
    message:
      'Weet u zeker dat u deze patiënt wilt verwijderen? Alle 3D-scans, E-limbs en onvoltooide producten die aan deze patiënt zijn gekoppeld, worden verwijderd. Bestelde producten blijven op de bestellingenpagina staan, maar kunnen niet worden gewijzigd.',
    confirmText: 'Verwijderen',
    success: 'Patiënt succesvol verwijderd',
    error: 'Fout bij verwijderen patiënt',
    elimb: {
      title: 'E-limb Verwijderen',
      message: 'Weet u zeker dat u deze E-limb wilt verwijderen?',
      success: 'E-limb succesvol verwijderd',
      error: 'Fout bij verwijderen E-limb',
    },
    scan: {
      title: 'Scan Verwijderen',
      message: 'Weet u zeker dat u deze scan wilt verwijderen?',
      success: 'Scan succesvol verwijderd',
      error: 'Fout bij verwijderen scan',
    },
  },
  onDeleteUser: {
    title: 'Gebruiker Verwijderen',
    message:
      'Weet u zeker dat u deze gebruiker wilt verwijderen? Alle patiënten, bestelde producten, 3D-scans en E-limbs die aan deze gebruiker zijn gekoppeld, worden overgedragen aan een andere gebruiker.',
    transferTo: 'Geef aan naar wie de gegevens worden overgedragen:',
    confirmText: 'Verwijderen',
    success: 'Gebruiker succesvol verwijderd',
    error: 'Fout bij het verwijderen van gebruiker',
    selectUserToTransfer: 'Gebruiker selecteren waarnaar de gegevens worden overgedragen',
    noUserToTransfer: 'Geen gebruiker geselecteerd om de gegevens over te dragen',
    lastAdmin:
      'Er moet altijd minstens één beheerder zijn. Neem contact op met OTB om dit te wijzigen.',
    forbidden: 'Je hebt geen toestemming om dit account te verwijderen.',
    referenced:
      'Dit account is nog gekoppeld aan andere gegevens en kon niet worden verwijderd. Er is niets gewijzigd — neem contact op met OTB.',
    invalidTransfer:
      'De gegevens kunnen alleen worden overgedragen aan een ander actief account van hetzelfde bedrijf. Er is niets gewijzigd — kies een andere gebruiker.',
  },
  onCreatePatient: {
    existingPatientName: {
      title: 'Bestaande patiënt',
      message:
        'U heeft een patiënt aangemaakt met dezelfde naam als een reeds bestaande patiënt: {fullName}.\nWilt u dit opslaan als een nieuwe patiënt of de bestaande patiënt bewerken?',
      confirmText: 'Opslaan als nieuwe patiënt',
      cancelText: 'Bestaande patiënt bewerken',
    },
    existingPatientId: {
      title: 'Bestaande patiënt',
      message:
        'U heeft een patiënt aangemaakt met dezelfde ID als een reeds bestaande patiënt: {fullName}.\nWilt u de bestaande patiënt bewerken of het aanmaken van de nieuwe patiënt annuleren?',
      confirmText: 'Bestaande patiënt bewerken',
      cancelText: 'Aanmaken patiënt annuleren',
      cancelMessage: 'Aanmaken patiënt geannuleerd',
    },
  },
  onEditPatient: {
    existingPatientName: {
      title: 'Bestaande patiënt',
      message:
        'U hebt een patiënt bijgewerkt met dezelfde naam als een reeds bestaande patiënt: {fullName}.\nWilt u uw wijzigingen toepassen op de huidige patiënt?',
      confirmText: 'Wijzigingen toepassen',
      cancelText: 'Update patiënt annuleren',
    },
  },
  actions: {
    edit: 'Bewerken',
    delete: 'Verwijderen',
    view: 'Patiënt bekijken',
    add: 'Patiënt toevoegen',
    save: 'Opslaan',
    cancel: 'Annuleren',
    continue: 'Doorgaan',
    reorder: 'Opnieuw bestellen',
    duplicate: 'Dupliceren',
    duplicateConfig: 'Configuratie dupliceren en bijwerken',
    addToCart: 'Aan winkelwagen toevoegen',
    removeFromCart: 'Uit winkelwagen verwijderen',
    upload: 'Uploaden',
    review: 'Product beoordelen',
  },
  messages: {
    created: 'Patiënt aangemaakt',
    updated: 'Patiënt bijgewerkt',
    deleted: 'Patiënt verwijderd',
    createError: 'Fout bij het aanmaken van patiënt',
    updateError: 'Fout bij het bijwerken van patiënt',
    deleteError: 'Fout bij het verwijderen van patiënt',
  },
  confirmations: {
    update: {
      title: 'Bijwerken',
      message: 'Weet u zeker dat u dit item wilt bijwerken?',
      confirmText: 'Bijwerken',
    },
    delete: {
      title: 'Verwijderen',
      message: 'Weet u zeker dat u dit item wilt verwijderen?',
      confirmText: 'Verwijderen',
    },
    create: {
      confirmText: 'Aanmaken',
    },
  },
  overviewPage: {
    title: 'Patiëntoverzicht',
    description: 'Bekijk en beheer patiëntgegevens',
    newProduct: 'Nieuw Product',
    noProducts: 'Geen producten beschikbaar',
    productId: 'Product-ID',
    productType: 'Producttype',
    createdOn: 'Gemaakt op',
    status: 'Status',
    newScan: 'Nieuwe Scan',
    noScans: 'Geen scans beschikbaar',
    scanId: 'Scan-ID',
    scanName: 'Scannaam',
    scannedLimb: 'Gescande Ledemaat',
    newElimb: 'Nieuwe E-limb',
    noElimbs: 'Geen e-limbs beschikbaar',
    elimbId: 'E-limb-ID',
    elimbType: 'E-limb Type',
    editNotes: 'Notities Bewerken',
    notesUpdated: 'Notities succesvol bijgewerkt',
    notesUpdateError: 'Fout bij het bijwerken van notities',
    scans: 'Scans',
    elimbs: 'E-limbs',
    products: 'Producten',
  },
  admin: {
    title: 'Beheerpaneel',
  },
  users: {
    title: 'Gebruikers',
    add: 'Gebruiker toevoegen',
    edit: 'Gebruiker bewerken',
    delete: 'Gebruiker verwijderen',
    sections: {
      generalInfo: 'Algemene Informatie',
      loginInfo: 'Login Informatie',
      roles: 'Rollen',
      passwordPicker: {
        title: 'Wie moet het wachtwoord instellen?',
        true: 'Jij',
        false: 'De gebruiker',
      },
      warning: {
        alert: 'Deze gebruiker heeft nog geen wachtwoord ingesteld.',
        button: 'Nieuwe e-mail versturen',
      },
      platformAccess: {
        title: 'Toegang tot het platform',
        field: 'Geblokkeerd',
      },
    },
    roles: {
      professional: 'Professional',
      admin: 'Beheerder',
      distributor: 'Distributeur',
      master: 'Master',
    },
    fields: {
      id: 'ID',
      fullName: 'Volledige naam',
      email: 'E-mail',
      phone: 'Telefoon',
      createdAt: 'Aangemaakt op',
      orderedProducts: 'Bestelde Producten',
      unfinishedProducts: 'Onvoltooide producten',
      roles: 'Rollen',
    },
    instructions: 'Instructies voor het beheren van gebruikers',
  },
  companies: {
    title: 'Bedrijven',
    add: 'Bedrijf toevoegen',
    edit: 'Bedrijf bewerken',
    delete: 'Bedrijf verwijderen',
    new: 'Nieuw Bedrijf',
    description: 'Nieuw bedrijf aanmaken',
    filterByDistributor: 'Filter op distributeur',
    addDistributor: 'Distributeur toevoegen',
    sections: {
      generalInfo: 'Algemene bedrijfsinformatie',
      settings: 'Instellingen',
      address: 'Adres',
      users: 'Gebruikers',
      companyOverview: 'Bedrijfsprofiel',
      productWorkflows: 'ProductWorkflows',
      supportTickets: 'Support Tickets',
      orderedProducts: 'Bestelde Producten',
      advancedSettings: 'Geavanceerde instellingen',
      productWorkflowStepConfigurationCard: {
        title: 'Stappen in de {material}-productworkflow weergeven / verbergen',
      },
    },
    fields: {
      name: 'Bedrijfsnaam',
      clientId: 'Klant-ID (minstens 4 tekens)',
      clientIdHeader: 'Klant-ID',
      generalEmail: 'Algemeen e-mailadres',
      generalPhone: 'Algemeen telefoonnummer',
      fullName: 'Volledige naam',
      deletedUser: 'Verwijderde gebruiker',
      email: 'E-mail',
      phone: 'Telefoon',
      line1: 'Adres',
      city: 'Stad & postcode',
      state: 'Provincie',
      postalCode: 'Postcode',
      country: 'Land',
      createdBy: 'Aangemaakt door',
      dateCreated: 'Aanmaakdatum',
      id: 'ID',
      openSupportTickets: 'Open Support Tickets',
      orderedProducts: 'Bestelde Producten',
      users: 'Gebruikers',
      unfinishedProducts: 'Onvoltooide producten',
    },
    settings: {
      useOwnPatientId: {
        label: 'Eigen patiënt-ID gebruiken',
        description:
          'Door dit aan te vinken kunt u uw eigen patiënt-ID definiëren, wat een verplicht veld wordt. Door dit uit te vinken zal het platform willekeurig patiënt-IDs genereren.',
      },
      sharePatients: {
        label: 'Patiënten delen tussen gebruikers',
        description:
          'Door dit aan te vinken kunnen alle gebruikers binnen deze organisatie alle patiënten zien, bewerken en producten voor hen maken. Door dit uit te vinken kan alleen de gebruiker die een patiënt aanmaakt deze zien, bewerken of een product voor hem maken.',
      },
      useShippingInformation: {
        label: 'Verzendgegevens gebruiken voor dochterbedrijven',
        description:
          'Door dit aan te vinken worden alle producten besteld door bedrijven die door deze organisatie zijn aangemaakt, verzonden en gekoppeld aan deze distributeur. (Niet bewerkbaar door de bedrijfsbeheerder)',
      },
      adminOrderFollowUp: {
        label: 'De beheerder wordt op de hoogte gehouden van bedrijfsbestellingen.',
        description:
          'Door dit vakje aan te vinken, krijgen de beheerders een e-mail wanneer een product wordt besteld.',
      },
      orderReferenceFollowUp: {
        label: 'Herinneringen voor orderreferenties.',
        description:
          'Door dit vakje aan te vinken, krijgt u dagelijks een herinnering om uw orderreferentie in te vullen als deze nog niet is ingevuld.',
      },
      credits: {
        title: 'Credits',
      },
      onlyAdminsCanBuyCredits: {
        label: 'Alleen beheerders kunnen credits kopen',
        description:
          'Door dit vakje aan te vinken kunnen professionals alleen credits aanvragen en kopen de beheerders ze.',
      },
      pricePerCredit: {
        label: 'Prijs per credit (EUR)',
        description:
          'Wat een credit deze organisatie kost in euro. Laat 0 staan om de prijs van de distributeur over te nemen, of anders die van Orthobroker.',
      },
      creditPriceCarpi: {
        label: 'Carpi (credits)',
        description:
          'Credits, geen euro, die voor een Carpi-STL worden gerekend. Nul neemt de waarde van de distributeur over, of anders die van Orthobroker.',
      },
      creditPriceMino: {
        label: 'Mino (credits)',
        description:
          'Credits, geen euro, die voor een Mino-STL worden gerekend. Nul neemt de waarde van de distributeur over, of anders die van Orthobroker.',
      },
      creditPriceVolar: {
        label: 'Volar (credits)',
        description:
          'Credits, geen euro, die voor een Volar-STL worden gerekend. Nul neemt de waarde van de distributeur over, of anders die van Orthobroker.',
      },
      notifications: {
        success: 'Bedrijfsinstellingen bijgewerkt.',
        error: 'Er is een fout opgetreden tijdens het bijwerken van de bedrijfsinstellingen.',
      },
    },
    whitelabel: {
      title: 'Whitelabel',
      logo: {
        label: 'Bedrijfslogo',
        description:
          'Vervangt het OrthoSolid-logo voor de gebruikers van dit bedrijf. PNG, JPG of WebP, tot 2 MB.',
        upload: 'Afbeelding kiezen',
        remove: 'Logo verwijderen',
        removeTitle: 'Bedrijfslogo verwijderen',
        removeMessage:
          'Het logo van dit bedrijf verwijderen? De gebruikers zien dan weer het OrthoSolid-logo.',
        empty: 'Geen bedrijfslogo — gebruikers zien het OrthoSolid-logo.',
      },
      notifications: {
        success: 'Bedrijfslogo bijgewerkt.',
        removed: 'Bedrijfslogo verwijderd.',
        error: 'Er is een fout opgetreden tijdens het bijwerken van het bedrijfslogo.',
        notAllowed: 'Alleen master-gebruikers kunnen het bedrijfslogo wijzigen.',
        noFile: 'Kies eerst een afbeelding.',
        invalidType: 'Dat bestand is geen ondersteunde afbeelding. Gebruik PNG, JPG of WebP.',
        tooLarge: 'Die afbeelding is te groot. De maximale grootte is 2 MB.',
      },
    },
    actions: {
      create: {
        errorPrefix: 'Fout bij het aanmaken van het bedrijf:',
      },
      delete: {
        button: 'Bedrijf verwijderen',
        title: 'Bedrijf verwijderen',
        message: 'Weet u zeker dat u dit bedrijf wilt verwijderen?',
        success: 'Het bedrijf is succesvol verwijderd',
        error: 'Er is een fout opgetreden bij het verwijderen van het bedrijf',
      },
      edit: {
        success: 'Het bedrijf is succesvol bijgewerkt.',
        errorPrefix: 'Fout bij het bijwerken van het bedrijf:',
      },
      companyID: 'Een bedrijfs-ID is vereist.',
      error:
        'De Klant-ID mag alleen letters, cijfers, punten, koppeltekens en onderstrepingstekens bevatten.',
      saveDecisionFlowOptions: {
        success: 'De opties die dit bedrijf in {flow} mag kiezen zijn opgeslagen.',
        notAllowed:
          'U kunt alleen de opties instellen van bedrijven die u hebt geregistreerd, binnen uw eigen opties.',
        error:
          'De opties voor {flow} konden niet worden opgeslagen. Laad de pagina opnieuw en probeer het nog eens.',
      },
      toggleProductWorkflowStepConfigurations: {
        field: 'Schakel de stappen van de {material}-productworkflow in / uit',
        productionLocation: {
          title: 'Productielocatie',
        },
        material: {
          title: 'Materiaal',
        },
        thumbSupport: {
          title: 'Duimondersteuning',
        },
        braceLength: {
          title: 'Lengte van de beugel',
        },
        openingLocation: {
          title: 'Openingslocatie',
        },
        hinges: {
          title: 'Scharnieren',
        },
        hingedOption: {
          title: 'Optie met scharnier',
        },
        padding: {
          title: 'Vulling',
        },
        extraPadding: {
          title: 'Extra vulling',
        },
        straps: {
          title: 'Riemen',
        },
      },
      duplicateConfig: {
        title: 'Dupliceer product naar een nieuwe configuratie',
        noOutcome:
          'Geen enkele configuratie past bij deze antwoorden. Wijzig een antwoord, of vraag een beheerder om de beslisboom aan te vullen.',
      },
    },
    instructions: `##### **Wat te doen?**
Vul de (verplichte) velden in om een nieuw bedrijf/distributeur aan te maken en wijs een gebruiker toe aan het bedrijf.
##### **Tips:**
- De verplichte velden zijn aangegeven met een *
- Als u geen patiënt-ID invult, genereert de software er automatisch een. U kunt dit later wijzigen`,
  },
  roles: {
    title: 'Rollen',
    admin: 'Admin',
    distributor: 'Distributeur',
    master: 'Master',
    user: 'Gebruiker',
  },
  status: {
    pending: 'Bestelling In Afwachting',
    inProgress: 'Bestelling In Behandeling',
    completed: 'Bestelling Voltooid',
    cancelled: 'Bestelling Geannuleerd',
  },
  orders: {
    title: 'Bestellingen',
    new: 'Nieuwe Bestelling',
    details: 'Bestelgegevens',
    status: 'Status',
    date: 'Besteldatum',
    id: 'Bestelnummer',
    placeOrder: 'Bestelling plaatsen',
    sections: {
      generalInfo: 'Algemene Informatie',
      shippingInfo: 'Verzendgegevens',
    },
    fields: {
      status: 'Status',
      reference: 'Referentie',
      clientId: 'Klant-ID',
      id: 'ID',
      created: 'Gemaakt',
      totalItems: 'Totaal aantal artikelen',
      notes: 'Notities',
      companyName: 'Bedrijf',
      material: 'Materiaal',
    },
    email: {
      received:
        'We willen je graag laten weten dat we je bestelling hebben ontvangen en deze binnenkort zullen verwerken. Hieronder vindt u de gegevens van uw bestelling:',
      beingPrepared:
        'Je bestelling wordt voorbereid en we laten het je weten zodra het onderweg is. Je kunt de voortgang volgen door de bestelstatus in het platform te controleren.Mocht je vragen hebben of verdere hulp nodig hebben, neem dan gerust contact met ons op via orders@orthosolid.com.',
      signature: 'Vriendelijke groeten,\nHet Orthobroker-team\nhttps://platform.orthosolid.com',
    },
  },
  shipping: {
    title: 'Verzendgegevens',
    name: 'Volledige Naam',
    email: 'E-mail',
    phone: 'Telefoon',
    address: 'Adres',
    city: 'Stad',
    postalCode: 'Postcode',
    country: 'Land',
  },
  preview: {
    demo: 'Demo voorvertoning',
    noPreview: 'Geen voorbeeld beschikbaar',
    noGlbFound: 'Geen GLB gevonden',
    loading: 'Laden...',
  },
  modelPreview: {
    orientationLabel: 'Oriëntatie',
    autoOrientation: 'Automatische oriëntatie',
    autoOrientationTooltip: 'Automatische oriëntatie gebaseerd op modelafmetingen',
    xAxisUp: 'X-as omhoog',
    xAxisUpTooltip: 'Draaien om X-as verticaal te maken',
    yAxisUp: 'Y-as omhoog',
    yAxisUpTooltip: 'Standaard verticale oriëntatie',
    zAxisUp: 'Z-as omhoog',
    zAxisUpTooltip: 'Draaien om Z-as verticaal te maken',
    error: 'Er is nog geen model om weer te geven.',
    unavailableCombination: 'Deze combinatie is niet beschikbaar.',
  },
  support: {
    title: 'Hulp vragen',
    description1:
      'Bedankt voor uw bericht, we helpen u graag bij het oplossen van uw probleem. Om ervoor te zorgen dat we alle gebruikers de juiste ondersteuning kunnen bieden, willen we u laten weten dat er een uitgebreide platformhandleiding is die u kunt raadplegen bij problemen.',
    description2:
      'Als uw probleem niet in de handleiding wordt behandeld, beschrijf het dan hieronder. We zullen er binnen 24 uur naar kijken (tijdens werkdagen). U ontvangt een melding wanneer we uw ticket hebben behandeld',
    manualButton: 'Platformhandleiding',
    issueLabel: 'Beschrijf uw probleem',
    issuePlaceholder: 'Beschrijf hier uw probleem...',
    createButton: 'Ticket aanmaken',
    typeLabel: 'Betreft',
    typePlaceholder: 'Kies een onderwerp',
    addTicket: 'Ticket toevoegen',
    platformManual: 'Platformhandleiding',
    platformManualDescription: 'Lees de richtlijnen of zoek naar een functionaliteit',
    academy: 'Academie',
    academyDescription: 'Word een expert door middel van videotutorials',
    button: 'Markeren als opgelost',
    notification: {
      resolved: {
        success: 'Gemarkeerd als opgelost',
        error:
          'Er is een onverwachte fout opgetreden tijdens het markeren als opgelost. Probeer het opnieuw.',
      },
      under_investigation: {
        success: 'Gemarkeerd als in onderzoek',
        error:
          'Er is een onverwachte fout opgetreden tijdens het markeren als in onderzoek. Probeer het opnieuw.',
      },
    },
  },
  buttons: {
    back: 'Terug',
    cancel: 'Annuleren',
    save: 'Opslaan',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    add: 'Toevoegen',
    select: 'Selecteren',
    selected: 'Geselecteerd',
    discover: 'Ontdekken',
    readMore: 'Meer lezen',
    continue: 'Doorgaan',
    clear: 'Wissen',
  },
  errors: {
    notFound: {
      title: '404',
      subtitle: 'Pagina niet gevonden',
      description: 'De pagina die u zoekt bestaat niet of is verplaatst.',
      action: 'Terug naar home',
    },
    general: {
      title: 'Er is iets misgegaan!',
      description: 'Er is een onverwachte fout opgetreden. Probeer het opnieuw.',
      action: 'Opnieuw proberen',
    },
    noAccess: 'Geen toegang',
    duplicate: {
      error: 'Er is een fout opgetreden bij het dupliceren van het product.',
    },
  },
  createUser: {
    errors: {
      alreadyExists:
        'Deze gebruiker heeft al een actief account. Neem contact op met je beheerder als het wachtwoord opnieuw moet worden ingesteld.',
      passwordLength: 'Het wachtwoord moet minimaal 6 tekens lang zijn.',
      error: 'Fout bij het aanmaken van de authenticatie:',
      noEmail:
        'Er is een fout opgetreden bij het ophalen van je e-mail. Neem contact op met de helpdesk.',
      JWTExpired: {
        new: 'Je uitnodiging voor het OrthoSolid-platform is verlopen. Neem contact op met je beheerder om een nieuwe aan te vragen.',
        reset:
          'Je uitnodiging om je wachtwoord opnieuw in te stellen is verlopen. Neem contact op met je beheerder voor een nieuwe uitnodiging.',
      },
    },
    subject: 'Stel je wachtwoord voor OrthoSolid in.',
    mail: `Beste {fullName},
    
    Je beheerder heeft een account voor je aangemaakt op het OrthoSolid-platform.
    Ga naar deze link om een wachtwoord aan te maken: {passwordURL}

    Met vriendelijke groeten,
    Het OrthoSolid-team. 
    `,
    html: `
      <p>Beste {fullName},</p>
      <p>
        Je beheerder heeft een account voor je aangemaakt op het OrthoSolid-platform.
        Ga naar <a href="{passwordURL}">deze link</a> om een wachtwoord aan te maken.
      </p>
      <p>
        Met vriendelijke groet,<br />
        Het OrthoSolid-team.
      </p>
    `,
  },
  onResetPassword: {
    message:
      'Zodra de gebruiker op ‘Doorgaan’ klikt, wordt er een e-mail naar hem of haar verzonden. De gebruiker wordt vervolgens doorgestuurd naar een pagina waar hij of zij het wachtwoord kan resetten.',
    success: 'De e-mail is naar de gebruiker verzonden.',
    error: 'Er is een fout opgetreden bij het verzenden van de e-mail naar de gebruiker.',
    mail: {
      subject: 'Stel je wachtwoord voor het Orthosolid-platform opnieuw in.',
      text: `Beste {fullName},
    
    Je beheerder heeft een verzoek ingediend om je wachtwoord te resetten.
    Klik op deze link om je wachtwoord te resetten: {passwordURL}

    Met vriendelijke groeten,
    Het OrthoSolid-team. 
    `,
      html: `
      <p>Beste {fullName},</p>
      <p>
        Je beheerder heeft een verzoek ingediend om je wachtwoord te resetten.
        Ga naar <a href="{passwordURL}">deze link</a> om je wachtwoord te resetten.
      </p>
      <p>
        Met vriendelijke groet,<br />
        Het OrthoSolid-team.
      </p>
    `,
    },
    errorUserWithoutPassword:
      '<p>Deze gebruiker heeft een account aangemaakt, maar nog geen wachtwoord. Ga naar <a href="{passwordURL}">deze link</a> om er een in te stellen.</p>',
  },
  common: {
    language: 'Taal',
    loading: 'Laden...',
    noResults: 'Geen resultaten gevonden',
    search: 'Zoeken',
    noValue: '-',
    loadingPage: 'Pagina laden...',
    loadingData: 'Gegevens laden...',
    processing: 'Verwerken...',
    removeFromCart: 'Uit winkelwagen verwijderen',
    fields: {
      created: 'Gemaakt',
    },
    cancel: 'Annuleren',
    hiddenData: 'Deze gegevens zijn verborgen',
  },
  onResendNewPasswordMail: {
    title: 'Send a new password mail',
    message:
      'Zodra de gebruiker op ‘Doorgaan’ klikt, wordt er een e-mail naar hem of haar verzonden. De gebruiker wordt vervolgens doorgestuurd naar een pagina waar hij of zij opnieuw een wachtwoord kan instellen.',
  },
  ticketDetails: {
    generalInfo: 'Algemene ticket informatie',
    involving: 'Betreft',
    ticketId: 'Ticket ID',
    scanId: 'Scan ID',
    createdOn: 'Aangemaakt op',
    createdBy: 'Aangemaakt door',
    lastAdjusted: 'Laatst aangepast op',
    lastAdjustedBy: 'Aangepast door',
    delete: 'Verwijderen',
    deleteTitle: 'Ticket verwijderen',
    deleteConfirm: 'Weet u zeker dat u dit ticket wilt verwijderen?',
    deleteSuccess: 'Ticket verwijderd',
    deleteError: 'Fout bij verwijderen ticket',
    resolveTicket: 'Ticket oplossen',
    ticketResolved: 'Ticket opgelost',
  },
  productCatalogue: {
    title: 'Productcatalogus',
    viewAll: 'Alles bekijken',
  },
  discussion: {
    title: 'Discussie',
    newMessage: 'Nieuw Bericht',
    send: 'Versturen',
    reply: 'Beantwoorden',
  },
  form: {
    save: 'Wijzigingen opslaan',
    delete: 'Verwijderen',
    required: 'Verplicht',
    enterValue: 'Waarde invoeren',
    selectDate: 'Selecteer datum',
    slider: {
      autoAdjust: 'Automatische berekening in-/uitschakelen',
    },
  },
  notes: {
    title: 'Notities',
    edit: 'Notities bewerken',
    placeholder: 'Notities invoeren',
    updated: 'Notities bijgewerkt',
    updateError: 'Fout bij bijwerken notities',
  },
  referenceNumber: {
    title: 'Referentienummer',
    placeholder: 'Uw referentienummer van de bestelling (indien van toepassing)',
  },
  notifications: {
    success: 'Succes',
    error: 'Fout',
    info: 'Informatie',
    warning: 'Waarschuwing',
    company: {
      created: 'Bedrijf succesvol aangemaakt',
      deleted: 'Bedrijf succesvol verwijderd',
      deleteError: 'Fout bij verwijderen bedrijf',
      updated: 'Bedrijf succesvol bijgewerkt',
      updateError: 'Fout bij bijwerken bedrijf',
    },
    order: {
      created: 'Bestelling succesvol aangemaakt',
      createError: 'Fout bij aanmaken bestelling! Neem contact op met de klantenservice.',
      insufficientCredits:
        'Niet genoeg credits voor deze bestelling. Vul uw credits aan en probeer het opnieuw.',
      creditsMisconfigured:
        'Deze bestelling kon niet in credits worden berekend. Neem contact op met OrthoSolid — meer credits kopen lost dit niet op.',
    },
    user: {
      created: 'Gebruiker succesvol aangemaakt',
      createError: 'Fout bij aanmaken gebruiker',
    },
    product: {
      addedToCart: 'Product aan winkelwagen toegevoegd',
      removedFromCart: 'Product uit winkelwagen verwijderd',
      cartError: 'Fout bij bijwerken winkelwagen',
      duplicated: 'Het product is correct gedupliceerd.',
      duplicatedConfig: 'Het product is correct gedupliceerd met een nieuwe configuratie.',
      deleted: 'Product succesvol verwijderd',
      deleteError: 'Fout bij verwijderen product',
    },
    model: {
      loadError: 'Fout bij laden model',
    },
    message: {
      creditsLow: {
        subject: 'Laag creditsaldo',
        message:
          'Je organisatie heeft nog {balance} credits, niet genoeg voor nog een digitaal bestand. Vul aan om te blijven bestellen.',
      },
      creditsRequested: {
        subject: 'Credits aangevraagd',
        message: '{requesterName} heeft {credits} extra credits aangevraagd voor je organisatie.',
      },
      orderPlaced: {
        subject: 'Bestelling #{orderId} geplaatst',
        message: 'Uw bestelling is succesvol geplaatst.',
      },
      orderInProcess: {
        subject: 'Bestelling #{orderId} is in behandeling',
        message: 'Alle producten uit uw bestelling worden momenteel geproduceerd.',
      },
      orderDelayed: {
        subject: 'Bestelling #{orderId} heeft vertraging',
        message:
          'Er is een fout opgetreden bij je bestelling. We nemen indien nodig contact met je op.',
      },
      orderShipped: {
        subject: 'Bestelling #{orderId} afgerond',
        message: 'Alle artikelen uit je bestelling zijn verzonden en worden binnenkort geleverd.',
      },
      orderInvoiced: {
        subject: 'Bestelling #{orderId} gefactureerd',
        message: 'Uw bestelling #{orderId} is gefactureerd.',
      },
      productUpdated: {
        subject: 'Product update: {productName} - {productId}',
        message:
          'Het product "{productName}" (ID: {productId}) is bijgewerkt door ons support team.',
      },
      supportHasReactedToYourHelpRequest: {
        subject: '{productName} {productId} is bijgewerkt door de klantenservice',
        message: 'We hebben gereageerd op je verzoek om hulp.',
      },
      announcement: {
        title: 'Nieuwe aankondiging',
        description:
          'Door op “Melding verzenden” te klikken, wordt een melding op het platform naar ALLE gebruikers verzonden.',
        confirmText: 'Melding verzenden',
        success: 'De melding is naar alle gebruikers verzonden.',
        error: 'Er is iets misgegaan bij het verzenden van de melding naar alle gebruikers.',
        form: {
          subject: {
            title: 'Onderwerp',
            placeholder: 'Voer een onderwerp in...',
          },
          message: {
            title: 'Bericht',
            placeholder: 'Voer uw bericht in...',
          },
          link: {
            title: 'Link',
            placeholder: 'Voer een link in naar de pagina waarnaar u de gebruiker wilt leiden...',
          },
        },
      },
      platformUpdates: {
        subject: 'Platform Updates',
        message: 'We hebben enkele wijzigingen aangebracht in het platform.',
        title: 'Nieuwe platformupdate',
      },
      newsletter: {
        subject: 'Newsletter',
        message: 'We hebben enkele wijzigingen aangebracht in het platform.',
      },
    },
    userUpdated: 'Gebruiker bijgewerkt',
    errorUpdatingUser: 'Fout bij het bijwerken van gebruiker',
    notificationsCleared: 'Meldingen gewist',
    notificationSettingsUpdated: 'Meldingsinstellingen bijgewerkt',
    patientDataUpdated: 'Patiëntgegevens succesvol bijgewerkt',
    patientDataUpdateFailed: 'Bijwerken van patiëntgegevens mislukt',
    fileDownloadedSuccessfully: '3D-bestand succesvol gedownload',
    supportEditsAccepted: 'Support-wijzigingen geaccepteerd',
    supportEditsFailed: 'Support-wijzigingen konden niet worden toegepast',
    changeRequestSubmitted: 'Wijzigingsverzoek succesvol ingediend',
    changeRequestFailed: 'Wijzigingsverzoek kon niet worden ingediend',
    mustBeLoggedIn: 'U moet ingelogd zijn om wijzigingen aan te vragen',
    commentMinLength:
      'Geef een opmerking van minimaal {minLength} tekens voor uw wijzigingsverzoek',
    delete: {
      title: 'Melding verwijderen',
      message: 'Weet u zeker dat u deze melding wilt verwijderen?',
      confirmText: 'Verwijderen',
      success: 'Melding verwijderd',
    },
  },
  navigation: {
    back: 'Terug',
    backToList: 'Terug naar lijst',
    backToOverview: 'Terug naar overzicht',
    breadcrumbs: 'Kruimelpad navigatie',
    currentPage: 'Huidige pagina',
    menu: {
      dashboard: 'Dashboard',
      patients: 'Patiënten',
      products: 'Producten',
      orders: 'Bestellingen',
      explore: 'Ontdekken',
      support: 'Ondersteuning',
      admin: 'Administratie',
      manufacturing: 'Productie',
      documentation: 'Documentatie',
    },
  },
  editor: {
    save: 'Wijzigingen opslaan',
    cancel: 'Annuleren',
    discard: 'Wijzigingen ongedaan maken',
    confirmDiscard: 'Weet u zeker dat u uw wijzigingen ongedaan wilt maken?',
  },
  menu: {
    notifications: 'Meldingen',
    messages: 'Berichten',
    cart: 'Winkelwagen',
    settings: 'Instellingen',
    toggleMenu: 'Menu schakelen',
    closeMenu: 'Menu sluiten',
    account: 'Account',
    createNew: 'Nieuw',
    noNotifications: 'Geen meldingen',
    noProducts: 'Er zijn geen producten in uw winkelwagen',
    goToCheckout: 'Naar kassa gaan',
    accountSettings: 'Accountinstellingen',
    logout: 'Uitloggen',
    newProduct: 'Nieuw product',
    newDistributorUser: 'Nieuwe distributeur gebruiker',
    newMasterUser: 'Nieuwe hoofdgebruiker',
    order: 'Bestelling bekijken',
    reactionFromSupport: 'Wijzigingen bekijken',
    announcement: 'Meer ontdekken',
    platformUpdates: 'Bekijk wat er nieuw is',
    continue: 'Doorgaan',
  },
  details: {
    noLabel: 'Geen label',
    noValue: 'Geen waarde',
    viewDetails: 'Details bekijken',
    moreInfo: 'Meer informatie',
  },
  cards: {
    viewItem: '{name} bekijken',
    selectItem: '{name} selecteren',
    imageAlt: 'Afbeelding van {name}',
    showInfo: 'Informatie tonen',
    hideInfo: 'Informatie verbergen',
    favourite: 'Product als favoriet markeren',
    companyFavourite: 'Mark product as company favourite',
  },
  translation: {
    translate: 'Tekst vertalen',
    translateTo: 'Vertalen naar {language}',
    translating: 'Bezig met vertalen...',
    translationError: 'Fout bij vertalen',
    defaultLanguage: 'Standaardtaal',
  },
  brand: {
    name: 'OrthoSolid',
    logoAlt: 'Logo OrthoSolid',
  },
  fileUpload: {
    attachFile: 'Bestand toevoegen',
    dragAndDrop: 'Sleep bestanden hierheen',
    browse: 'Bladeren',
    maxSize: 'Maximale bestandsgrootte: {size}',
    invalidType: 'Ongeldig bestandstype',
    uploadError: 'Fout bij uploaden',
    loadError: 'Kan 3D-bestandsvoorbeeld niet laden',
    gltfExternalRefs:
      'GLTF-bestanden met externe referenties worden niet ondersteund. Gebruik in plaats daarvan het GLB-formaat.',
    uploadSuccess: 'Bestand succesvol geüpload',
    remove: 'Bestand verwijderen',
    validating: 'Bestanden valideren...',
    filesNotSupported:
      'Bestand(en) niet ondersteund: {rejectedNames}. Ondersteunde formaten: {acceptedFormats}',
    filesSelected: '{count} van {max} bestanden geselecteerd',
    uploadInstructions:
      'Uw bestand wordt geüpload. Na het uploaden kunt u de 3D-scan opschonen en verbeteren met onze 3D Cleaner-tool in de volgende stap.',
    charactersMinimum: '{count}/{min} tekens minimum',
    color: {
      label: 'Kleur',
      incoming: 'Geen kleur (bestandskleur gebruiken)',
      presets: {
        white: 'Wit',
        skin: 'Huid',
        blue: 'Blauw',
        green: 'Groen',
        red: 'Rood',
        black: 'Zwart',
      },
    },
  },
  supportTicket: {
    discussion: 'Discussie',
    typeMessage: 'Typ een bericht...',
    send: 'Versturen',
    attachFile: 'Bestand toevoegen',
    noComments: 'Nog geen opmerkingen',
    addComment: 'Opmerking toevoegen',
    uploadFile: 'Bestand uploaden',
    close: 'Sluiten',
    success: 'Supportticket aangemaakt.',
    error: 'Fout bij het aanmaken van supportticket.',
    status: {
      received: 'Ontvangen',
      under_investigation: 'Onder onderzoek',
      on_hold: 'In de wacht',
      resolved: 'Opgelost',
    },
    productStatus: {
      dataInput: 'Gegevens invoeren',
      designing: 'Aan het ontwerpen',
      readyToOrder: 'Klaar om te bestellen',
      inCart: 'In winkelwagen',
      helpRequested: 'Hulp aangevraagd',
      updatedBySupport: 'Bijgewerkt door support',
      ordered: 'Besteld',
      demo: 'Demo',
      designRequested: 'Ontwerp aangevraagd',
      orderedWithoutReview: 'Besteld zonder nood aan beoordeling',
      cancelled: 'Geannuleerd',
    },
    orderStatus: {
      orderPlaced: 'Order geplaatst',
      processing: 'In behandeling',
      shipped: 'Afgerond',
      invoiced: 'Gefactureerd',
      delayed: 'Vertraagd',
      ignore: 'Negeren',
      demo: 'Demo',
      designRequested: 'Ontwerp aangevraagd',
      orderedWithoutReview: 'Besteld zonder nood aan beoordeling',
      readyForReview: 'Klaar voor beoordeling',
      generating3dFile: '3D-bestand genereren',
      threeDFileUnderReview: '3D-bestand wordt beoordeeld',
      threeDFileAvailable: '3D-bestand beschikbaar',
      downloaded: 'Gedownload',
    },
    exportStatus: {
      notAvailable: 'N.v.t.',
      generating: 'Genereren',
      failed: 'Mislukt',
      missing: 'Ontbreekt',
      emptyFile: 'Leeg bestand',
      valid: 'Geldig',
    },
    buttonText: 'Stuur een bericht met een link naar het model',
  },
  workflow: {
    back: 'Terug',
    next: 'Volgende',
    save: 'Opslaan',
    exit: 'Afsluiten',
    continue: 'Doorgaan',
    cancel: 'Annuleren',
    finish: 'Voltooien',
    instructions: 'Instructies',
    steps: {
      current: 'Huidige stap',
      previous: 'Vorige stap',
      next: 'Volgende stap',
    },
    navigation: {
      back: 'Teruggaan',
      forward: 'Vooruit',
      exit: 'Workflow verlaten',
    },
  },
  patientData: {
    add: 'Patiëntgegevens toevoegen',
    notFinished: 'Niet voltooid',
    fields: {
      name: 'Naam',
    },
    scanOrientation: {
      label: 'Scan oriëntatie',
      placeholder: 'Selecteer scan oriëntatie',
      left: 'Linker',
      right: 'Rechter',
    },
    dataType: {
      label: 'Datatype',
      file: 'Bestand',
      measurement: 'Meting',
      form: 'Formulier',
    },
    upload: {
      alignScan: 'Scan uitlijnen',
      defineSide: 'Scan zijde definiëren',
      selectFile: 'Selecteer een bestand en scan oriëntatie',
      uploadError: 'Fout bij uploaden bestand',
      description: 'Selecteer een bestand en scan oriëntatie',
      action: 'Bestand uploaden',
    },
    createdOn: 'Aangemaakt op',
    notes: 'Notities',
    actions: {
      editScan: 'Scan bewerken',
      editMeasurements: 'Metingen bewerken',
      editForm: 'Formulier bewerken',
    },
    linkedProducts: 'Gekoppelde producten',
    newProduct: 'Nieuw product',
    noLinkedProducts: 'Geen gekoppelde producten gevonden',
    dataInput: 'Gegevensinvoer',
    selectDataInput: 'Selecteer een gegevensinvoer',
    createdBy: 'Gemaakt door',
    editTitle: 'Patiëntgegevens bewerken',
  },
  dataGrid: {
    bulkActions: {
      credits: {
        button: 'Credits',
        title: 'Credits instellen',
        description:
          'Alleen de velden die je invult worden gewijzigd. Laat een veld leeg om de huidige waarde van elk bedrijf te behouden.',
        keep: 'Niet wijzigen',
        enable: 'Inschakelen',
        disable: 'Uitschakelen',
        unchanged: 'Ongewijzigd',
        apply: 'Toepassen',
        success: 'Creditinstellingen bijgewerkt voor {count} bedrijven.',
        notAllowed: 'Je mag de creditinstellingen niet wijzigen.',
        noChanges: 'Niets te wijzigen. Vul minstens een veld in.',
        noCompanies: 'Selecteer minstens een bedrijf.',
        error: 'Fout bij het bijwerken van de creditinstellingen.',
      },
      scheduleExports: 'Exporten plannen',
      changeStatus: 'Status wijzigen',
      downloadProduction: 'Productiebestanden',
      downloadCsv: 'Bestelgegevens',
      downloadExports: 'Exporten',
      addToCart: 'Aan winkelwagen toevoegen',
      delete: 'Verwijderen',
      notifications: {
        statusSuccess: 'Status succesvol gewijzigd',
        statusError: 'Fout bij wijzigen status',
        productionSuccess: 'Productiebestanden succesvol gedownload',
        productionError: 'Fout bij downloaden productiebestanden',
        exportSuccess: 'Exports succesvol gedownload',
        exportErrorExplanation: 'Er zijn geen downloadbare producten gevonden.',
        exportErrorNoProducts: 'No downloadable products found.',
        exportErrorIncomplete:
          '{failed} of {total} files could not be downloaded ({products}). Check your connection and try again — nothing was marked as downloaded.',
        exportError: 'Fout bij exporteren',
        cartSuccess: 'Producten succesvol aan winkelwagen toegevoegd',
        cartError: 'Fout bij toevoegen producten aan winkelwagen',
        deleteSuccess: 'Producten succesvol verwijderd',
        deleteError: 'Fout bij verwijderen producten',
        exportsSuccess: 'Exporten succesvol gedownload',
        exportsError: 'Fout bij downloaden exporten',
        exportsGenerating: 'Exporten worden gegenereerd. Probeer het binnenkort opnieuw.',
        orderInfoSuccess: 'Bestelinfo succesvol gedownload',
        orderInfoError: 'Fout bij downloaden bestelinfo',
      },
    },
    filter: {
      title: 'Filter',
      apply: 'Filters toepassen',
      cancel: 'Annuleren',
    },
    showOnlyMyPatients: 'Toon alleen mijn patiënten',
    showOnlyMyOrders: 'Toon alleen mijn bestellingen',
    showOnlyMyProducts: 'Toon alleen mijn producten',
    search: 'Zoeken...',
    manageColumns: 'Kolommen beheren',
  },
  help: {
    requestHelp: 'Hulp vragen',
    newTicket: 'Nieuw ticket aanmaken',
    openTicket: 'Ticket openen',
    viewTicket: 'Ticket bekijken',
  },
  comments: {
    seeModel: 'Model bekijken',
    download: 'Downloaden',
    author: 'Door {name}',
    createdAt: 'Gemaakt op {date}',
    fileDetails: {
      name: 'Naam',
      size: 'Grootte',
      type: 'Type',
    },
    selectedFile: 'Geselecteerd bestand',
    removeFile: 'Bestand verwijderen',
  },
  footer: {
    exploreMore: 'Meer producten ontdekken',
    back: 'Terug',
    next: 'Volgende',
    exit: 'Opslaan en afsluiten',
    contact: 'Contact',
    location: 'Locatie',
    copyright: '© {year} Orthobroker bv',
    followUs: 'Volg ons',
    newsletter: 'Nieuwsbrief',
    getUpdates: 'Ontvang updates over onze nieuwste producten en aanbiedingen.',
    on: 'Aan',
    off: 'Uit',
    suscribed: 'U bent nu geabonneerd op onze nieuwsbrief',
    unsubscribed: 'U bent nu uitgeschreven voor onze nieuwsbrief',
    stayUpToDate: 'Blijf op de hoogte',
    form: {
      email: 'E-mail addres',
    },
  },
  visibility: {
    show: 'Gevoelige gegevens tonen',
    hide: 'Gevoelige gegevens verbergen',
  },
  dashboard: {
    startCreation: 'Start creatie proces',
    addNewPatient: 'Nieuwe patiënt toevoegen',
    addPatientData: 'Patiëntenscan toevoegen',
    continueDesigning: 'Doorgaan met ontwerpen',
    recentOrders: 'Recente bestellingen',
    viewAll: 'Alles bekijken',
    columns: {
      productName: 'Productnaam',
      patientName: 'Patiëntnaam',
      status: 'Status',
      orderDate: 'Besteldatum',
      orderId: 'Bestelnummer',
    },
  },
  redirect: {
    title: 'Omleiding Vereist',
    description: 'U moet enkele stappen voltooien voordat u toegang krijgt tot deze pagina.',
    patient: 'patiëntselectie',
    dataset: 'datasetselectie',
    product: 'productselectie',
    form: 'formselectie',
    goTo: 'Ga naar {destination}',
  },
  general: {
    back: 'Terug',
    exit: 'Opslaan & afsluiten',
    yes: 'Ja',
    no: 'Nee',
    on: 'Aan',
    off: 'Uit',
  },
  titles: {
    credits: 'Mijn credits',
    patient: 'Patiënt toewijzen',
    assignPatient: 'Patiënt toewijzen',
    createPatient: 'Nieuwe patiënt',
    product: 'Product selecteren',
    dataset: 'Dataset selecteren',
    selectForm: 'Formulier selecteren',
    editForm: 'Formulier bewerken',
    newForm: 'Nieuw formulier',
    selectElimb: 'E-limb selecteren',
    elimb: 'E-limb meten',
    selectScan: 'Scan selecteren',
    alignScan: 'Uitlijnen & schoonmaken',
    admin: 'Administratie',
    catalog: 'Catalogus',
    checkout: 'Kassa',
    academy: 'Academie',
    explore: 'Verkennen',
    orders: 'Bestellingen',
    tickets: 'Tickets',
    manufacturing: 'Productie',
    dashboard: 'Dashboard',
    patientData: 'Patiëntgegevens',
    products: 'Producten',
    productWorkflowCategory: 'Selecteer een categorie',
  },
  product: {
    code: 'Productcode',
    overview: {
      title: 'Product overzicht',
    },
    next: 'Dataset selecteren',
    sections: {
      generalInfo: 'Algemene product informatie',
      specifications: 'Product specificaties',
      details: 'Productgegevens',
    },
    fields: {
      status: 'Status',
      patient: 'Patiënt',
      type: 'Product type',
      id: 'Product ID',
      createdOn: 'Aangemaakt op',
      createdBy: 'Aangemaakt door',
      lastAdjustedOn: 'Laatst aangepast op',
      lastAdjustedBy: 'Laatst aangepast door',
      orderReference: 'Bestelreferentie',
      linkedScan: 'Gekoppelde scan',
      copyFrom: 'Kopie van',
      edgePiping: {
        0: 'Uit',
        1: 'Overal',
        2: 'Alleen met de hand',
        3: 'Alleen duim',
      },
      thumbWebFoldingEdge: {
        0: 'Uit',
        1: 'Laag',
        2: 'Medium',
        3: 'Hoog',
      },
      buckleType: {
        0: 'Geen gesp',
        1: 'FDM-lus',
      },
      dorsal: 'Dorsaal',
      palmar: 'Palmair',
      transversalPalmArchIntensity: {
        0: 'Geen',
        1: 'Laag',
        2: 'Medium',
        3: 'Hoog',
      },
      productFinishing: {
        0: 'Alleen geprinte schaal',
        3: 'Orthese met aangepaste voering',
        1: 'Orthese met aangepaste voering en aparte bandenset',
        2: 'Orthese met aangepaste voering en bevestigde banden',
      },
    },
    properties: {
      title: 'Producteigenschappen',
      edit: 'Eigenschappen Bewerken',
      hinge_type: 'Type Scharnier',
      brace_thickness: 'Verstevigingsdikte',
      material: 'Materiaal',
      finishing: 'Afwerking',
      error: 'Fout bij bewerken van eigenschappen',
    },
    actions: {
      delete: {
        title: 'Product verwijderen',
        message: 'Weet u zeker dat u dit product wilt verwijderen?',
        confirmText: 'Verwijderen',
        error:
          'Het product {id} kan niet worden verwijderd omdat het gekoppeld is aan Support Ticket {supportTicketId}.',
      },
      addToCart: 'Aan winkelwagen toevoegen',
      removeFromCart: 'Uit winkelwagen verwijderen',
      order: 'Ga naar de kassa',
      showSpecifications: 'Specificaties weergeven',
      showInfo: 'Productinformatie',
    },
    title: 'Product',
    new: 'Nieuw product',
    empty: 'Geen producten gevonden',
    description: 'Productbeschrijving',
    add: 'Product toevoegen',
    workflow: {
      instructions: {
        start: `##### **Wat wilt u doen?**
Kies de beste variant.
##### **Tips:**
- Klik op het informatie-icoon voor een korte beschrijving van het product`,
        overview: `##### **Overzicht**
Dit is de orthese die u gaat maken.
##### **Tips:**
- U kunt dit ontwerp als favoriet markeren door op de favorietknop te klikken.`,
        flowStepTitle: '##### **{number}. {question}**',
        overviewTitle: '##### **Overzicht**',
        flowStep: `##### **{number}. {question}**
Kies het antwoord dat het best bij uw patiënt past.
##### **Tips:**
- U kunt een eerder antwoord wijzigen door hierboven op de stap te klikken.`,
        noOutcome:
          'Geen enkel product past bij deze antwoorden. Ga terug en wijzig een antwoord, of vraag een beheerder om de beslisboom aan te vullen.',
        noFlow:
          'Deze productfamilie heeft nog geen actieve beslisboom. Vraag een beheerder om die te activeren.',
        noOptions: 'Voor deze stap is met de antwoorden tot nu toe geen antwoord beschikbaar.',
        outcomeFailed:
          'Het product bij deze antwoorden kon niet worden geladen. Controleer uw verbinding en laad de pagina opnieuw.',
        outcomeNoWorkflow:
          'Dit product heeft nog geen productworkflow en kan daarom niet worden aangemaakt. Vraag een beheerder er een in te stellen.',
        error: 'Er is een fout opgetreden bij het berekenen van het resultaat.',
      },
      thumbDiameter: {
        confirmText: 'Doorgaan',
        error: 'Voer een geldige duimdiameter in.',
      },
      hingedOption: {
        error: 'Voer een geldige optie voor uw scharnier in.',
      },
      extraPadding: {
        error: 'Geef hier aan of u extra padding wilt of niet.',
        chip: {
          yes: 'Extra padding',
          no: 'Geen extra padding',
        },
      },
      paddingThickness: {
        error: 'Voer een geldige waarde voor de dikte van de padding in.',
      },
      favourite: {
        title: 'Favoriet',
        success: 'Het product is gemarkeerd als favoriet.',
        error: 'Fout bij het markeren van de Carpi-productieconfiguratie als favoriet.',
      },
      unFavourite: {
        title: 'Verwijderen uit favorieten',
        message:
          'Weet u zeker dat u deze {product}-variant uit uw lijst met favorieten wilt verwijderen?',
        confirmText: 'Verwijder',
        success: 'Het product is niet langer gemarkeerd als favoriet.',
        error: 'Fout bij het onmarkeren van het product als favoriet.',
      },
      companyFavourite: {
        title: 'Bedrijfs favoriet',
        success: 'Het product is gemarkeerd als favoriet van het bedrijf.',
        error: 'Fout bij het markeren van het product als favoriet van het bedrijf.',
      },
      companyUnfavourite: {
        title: 'Het product niet meer markeren als favoriet van het bedrijf.',
        message:
          'Weet u zeker dat u deze {product}-variant wilt verwijderen uit uw lijst met favorieten van het bedrijf?',
        confirmText: 'Verwijder',
        success: 'Het product is niet meer gemarkeerd als favoriet voor het bedrijf.',
        error:
          'Er is een fout opgetreden bij het verwijderen van de markering van het product als favoriet voor het bedrijf.',
      },
      outcome: {
        title: 'Overzicht',
      },
      duplicate: {
        baskoMultimotion: 'Basko Multimotion',
        caroliDyna: 'Caroli Dyna',
        caroliMono: 'Caroli Mono',
        albrecht: 'Albrecht',
        ultraFlex: 'UltraFlex',
      },
    },
  },
  productWorkflowCategory: {
    instructions: `##### **Welk product heeft uw patiënt nodig?**
Selecteer een familie van producten.
##### **Tips:**
- Klik op het informatie-icoon voor een korte beschrijving van de producten
- Nadat je de productfamilie hebt gekozen, kun je kiezen welke variant je wilt maken`,
    next: 'Selecteer product',
  },
  patient: {
    info: 'Patiëntinformatie',
    instructions: `##### **Voor wie maakt u een product?**
Maak een nieuwe patiënt aan of wijs er een toe uit uw patiëntenlijst.`,
    new: 'Nieuwe patiënt',
    pick: 'Selecteer uit de patiëntenlijst',
    exit: 'Sluiten',
    next: 'Productcategorie selecteren',
    create: 'Nieuwe patiënt toevoegen',
    addPatient: 'Patiënt toevoegen',
    close: 'Sluiten',
    name: 'Patiëntnaam',
  },
  dataset: {
    elimb: {
      instructions: `##### **Wat zijn de afmetingen van de arm van de patiënt?**
Maak een nieuwe E-limb door je patiënt op te meten of selecteer er een uit het profiel van je patiënt.
##### **Tips:**
- Zorg ervoor dat als je een bestaande E-limb kiest, deze nog steeds up-to-date is
- Bij het maken van een nieuwe E-limb, zorg ervoor dat je de volgende hulpmiddelen bij de hand hebt: Schuifmaat, liniaal`,
      create: 'Nieuwe E-limb aanmaken',
      select: 'E-limb selecteren uit patiëntprofiel',
      empty: 'Geen E-limbs gevonden',
      next: 'E-limb aanmaken',
      save: 'Gewrichtshoeken definiëren',
    },
    scan: {
      instructions: `##### **Wat zijn de afmetingen van de arm van de patiënt?**
Upload een nieuwe 3D-scan of selecteer er een uit het profiel van je patiënt.
##### **Tips:**
- Zorg ervoor dat als je een bestaande 3D-scan kiest, deze nog steeds up-to-date is
- Wanneer je een nieuwe 3D-scan uploadt, moet je deze uitlijnen en opschonen.
- Om de perfecte scan te maken voor gebruik in deze software, zie Scan handleiding`,
      upload: 'Nieuwe 3D-scan uploaden',
      select: '3D-scan selecteren uit patiëntprofiel',
      empty: 'Geen 3D-scans gevonden',
      next: 'Scan schoonmaken',
      save: 'Schoongemaakte scan opslaan',
      custom: {
        next: 'Productbeschrijving',
      },
    },
    form: {
      assign: 'Formulier toewijzen',
      empty: 'Geen formulieren beschikbaar',
      instructions:
        '##### **Selecteer een formulier om door te gaan of maak een nieuw formulier aan**',
      select: 'Formulier selecteren',
      new: 'Nieuw formulier aanmaken',
      save: 'Formulier opslaan',
      next: 'Volgende stap',
      request: 'Product aanvragen',
      altNext: 'Product bestellen',
      altButton: 'Werk het formulier bij',
      name: {
        title: 'Geef uw formulier een naam.',
        placeholder: 'Voer een naam in',
      },
    },
    configure: 'Product creator',
  },
  list: {
    title: 'Producten',
    empty: 'Geen producten gevonden',
    fields: {
      productId: 'Product-ID',
      productType: 'Producttype',
      createdOn: 'Aangemaakt op',
      status: 'Status',
    },
    actions: {
      new: 'Nieuw',
    },
  },
  model: {
    locked:
      'Het model is momenteel vergrendeld omdat het is besteld of aan de winkelwagen is toegevoegd.',
  },
  mesh: {
    notFound: {
      title: 'Mesh niet gevonden',
      message: 'De mesh werd niet gevonden in de scene',
    },
    loaded: {
      title: 'Mesh geladen',
      message: 'Mesh succesvol geladen',
    },
    align: {
      title: 'Scan oplijnen',
      message:
        "Druk op 'Align Scan' voordat u de scan opslaat. (Sla opnieuw op 'Save'om door te gaan zonder uit te lijnen)",
    },
    clean: {
      title: 'Scan schoonmaken',
      message:
        "Druk op 'Clean Scan' voordat u de scan opslaat. (Sla opnieuw op 'Save' om door te gaan zonder schoon te maken)",
    },
  },
  settings: {
    title: 'Instellingen',
    sections: {
      company: 'Bedrijfsinstellingen',
      user: 'Gebruikersinstellingen',
      general: 'Algemene instellingen',
    },
    fields: {
      useOwnPatientId: {
        label: 'Eigen patiënt-ID gebruiken',
        description: 'Activeer deze optie om uw eigen patiënt-IDs te definiëren.',
      },
      sharePatients: {
        label: 'Patiënten delen',
        description: 'Activeer deze optie om patiënten te delen met andere gebruikers.',
      },
      useShippingInformation: {
        label: 'Verzendgegevens gebruiken',
        description: 'Activeer deze optie om verzendgegevens te gebruiken.',
      },
      anonymizedStartUp: {
        label: 'Anonieme start',
        description: 'Activeer deze optie voor een anonieme start.',
      },
      assistedMode: {
        label: 'Ondersteunde modus',
        description: 'Activeer deze optie voor de ondersteunde modus.',
      },
      preferredLanguage: {
        label: 'Voorkeurstaal',
        description: 'Selecteer uw voorkeurstaal.',
      },
    },
    myAccount: 'Mijn account',
    announcement: {
      button: 'Een nieuwe aankondiging versturen',
    },
    platformUpdate: {
      button: 'Een platformupdate versturen',
    },
    notificationSettings: 'Meldingsinstellingen',
    notifications: {
      inPlatform: 'In platform',
      byEmail: 'Per e-mail',
    },
  },
  scan: {
    title: '3D-Scan',
    fields: {
      id: 'Scan-ID',
      name: 'Scannaam',
      orientation: 'Scan-oriëntatie',
      lastAdjustedOn: 'Laatst aangepast op',
      lastAdjustedBy: 'Laatst aangepast door',
    },
  },
  elimb: {
    title: 'Elimb Information',
    fields: {
      id: 'Elimb ID',
      name: 'Elimb Naam',
      orientation: 'Elimb-oriëntatie',
      lastAdjustedOn: 'Laatst aangepast op',
      lastAdjustedBy: 'Laatst aangepast door',
    },
  },
  descriptions: {
    credits: 'Koop credits en bekijk wat uw organisatie nog kan printen.',
    admin: 'Administratie',
    catalog: 'Catalogus',
    checkout: 'Kassa',
    academy: 'Academie',
    explore: 'Verkennen',
    orders: 'Bestellingen',
    products: 'Producten',
    tickets: 'Tickets',
  },
  distributor: {
    create: 'Distributeur aanmaken',
    add: 'Gebruiker toevoegen',
  },
  cart: {
    empty: 'Winkelwagen leeg',
    delete: {
      title: 'Winkelwagen verwijderen',
      message: 'Weet u zeker dat u dit product wilt verwijderen?',
      confirmText: 'Verwijderen',
      success: 'Winkelwagen verwijderd',
    },
  },
  checkout: {
    title: 'Kassa',
    contactInformation: {
      title: 'Contactinformatie',
      description: 'Voer uw contactinformatie in',
    },
    products: {
      title: 'Producten',
      description: 'Controleer uw producten voordat u afrekent',
    },
  },
  academy: {
    title: 'Academie',
  },
  manufacturing: {
    title: 'Productie',
    orders: {
      title: 'Productie - Bestellingen',
      tab: 'Reguliere bestellingen',
    },
    designRequested: {
      title: 'Productie - Ontwerp aangevraagd',
    },
    ignoredItems: {
      title: 'Productie - Genegeerde artikelen',
      tab: 'Genegeerde artikelen',
    },
    creditOrders: {
      title: 'Productie - Creditaanvragen',
      tab: 'Creditaanvragen',
    },
    noItemsFound: 'Geen productieartikelen gevonden',
    stlFiles: 'STL-bestanden',
    rows: {
      selectRow: 'Rij selecteren',
      unselectRow: 'Rij de-selecteren',
      selectAllRows: 'Alle rijen selecteren',
      unselectAllRows: 'Alle rijen de-selecteren',
    },
  },
  tickets: {
    fields: {
      product: 'Product',
      status: 'Status',
      createdBy: 'Gemaakt door',
      id: 'ID',
      involving: 'Betrokken',
      description: 'Beschrijving',
      company: 'Bedrijf',
    },
  },
  products: {
    fields: {
      status: 'Status',
      name: 'Naam',
      patientName: 'Patiëntnaam',
      id: 'ID',
      notes: 'Notities',
      producedBy: 'Geproduceerd door',
    },
  },
  documentation: {
    title: 'Documentatie',
    notAvailable: 'Er is momenteel geen documentatie beschikbaar.',
    loading: 'Inhoud laden...',
    selectDocument: 'Selecteer een document uit de inhoudsopgave.',
  },
  explore: {
    title: 'Verkennen',
  },
  formFields: {
    togglePasswordVisibility: 'wachtwoordzichtbaarheid omschakelen',
  },
  features: {
    currentlyDisabled: 'Deze functie is momenteel uitgeschakeld',
  },
  components: {
    selectPatient: 'Selecteer een patiënt',
    patientLabel: 'Patiënt',
    meshInspectorFrame: 'MeshInspector-frame',
    doNotShowAgain: 'Toon deze pop-up niet de volgende keer',
    submitText: 'Begin met ontwerpen',
    supportPreview: {
      title: 'Supportvoorbeeld',
      description:
        'U bekijkt een voorbeeld van ondersteuning. Accepteer wijzigingen om door te gaan',
      accept: 'Accepteer wijzigingen',
    },
    modelPreviews: {
      viewSelection: 'modelweergaveselectie',
      productView: 'productweergave',
      patientDataView: 'patiëntgegevensweergave',
      finalProduct: 'Eindproduct',
      threeDScan: '3D-Scan',
    },
    meshInspector: {
      saveWarnings: {
        title: 'Scan opslaan',
        lead: 'Let vóór het opslaan op het volgende:',
        notCleanedBullet: "De mesh is niet opgeschoond. Gebruik 'Clean Scan' om hem te herstellen.",
        notAlignedBullet: "De scan is niet uitgelijnd. Gebruik 'Align Scan' om hem te oriënteren.",
        proceed: 'Toch opslaan',
      },
    },
    customProducts: {
      noFormDataAvailable: 'Geen formuliergegevens beschikbaar voor dit product.',
      changeRequestHistory: 'Wijzigingsverzoek Geschiedenis',
      anonymous: 'Anoniem',
      uploadModel: 'Model uploaden',
      uploadModelTitle: 'Model Uploaden',
      productFormData: 'Productformuliergegevens',
      requestChangesButton: {
        title: 'Wijzigingen aanvragen',
        description:
          'Deze aanvraag wijzigt de productstatus en stelt het OrthoSolid-team op de hoogte. Ons team zal uw feedback beoordelen en een nieuwe versie van het product leveren op basis van uw specificaties.',
      },
      buttons: {
        orderTitle: 'Accepteer en bestel',
      },
      images: {
        title: 'Bijgevoegde afbeeldingen',
        description: 'Nieuwe afbeeldingen uploaden',
      },
      requestProduct: {
        dialog: {
          title: 'Vraag een gepersonaliseerd product aan',
          message: `Wanneer u dit product aanvraagt, maken wij een ontwerp op maat en ontvangt u uiteindelijk een factuur.\n\n**Belangrijk:**\n\nHoud er rekening mee dat het tot 3 werkdagen kan duren voordat het ontwerp klaar is. U wordt op de hoogte gehouden via de platformmeldingen en e-mail.`,
          confirmText: 'Product aanvragen',
        },
      },
      orderProduct: {
        dialog: {
          title: 'Product bestellen',
          message: `Als je dit product bestelt, maken en printen we een ontwerp op maat zonder dat je dit hoeft te checken. Het product wordt verzonden en gefactureerd.\n\n**Belangrijk:**\n\nHoud er rekening mee dat het tot 12 werkdagen kan duren voordat het product is gemaakt. Je wordt op de hoogte gehouden via platformmeldingen en e-mail.`,
          confirmText: 'Product bestellen',
        },
      },
      updateForm: {
        dialog: {
          title: 'Formulier bijwerken',
          message:
            'Door het formulier bij te werken, wordt dit ook toegepast op andere producten die dit formulier gebruiken.',
        },
      },
    },
  },
  youtubeEmbed: {
    player: 'YouTube-speler',
    allowedFeatures:
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
  },
  configurator: {
    calculating: 'Aan het berekenen...',
    error: {
      title: 'Fout',
      description: 'Product niet gevonden.',
      brace: {
        title: 'Een beugel moet worden berekend voordat u deze kunt verbergen.',
      },
    },
    menu: {
      customTextLimit: 'Voer maximaal 20 tekens in. ({length} gebruikt)',
      notes: {
        title: 'Informatie voor productie',
        productLabel: 'Vermeld de naam van de patiënt op het productetiket',
        placeholder: 'Klik om notities toe te voegen...',
      },
    },
  },
  volarShell: {
    error: {
      noAcces: 'Je hebt geen toegang tot dit product.',
      noShell: 'Er is geen shell-bestand beschikbaar voor dit product.',
      couldNotGenerate: 'Er kon geen downloadlink voor het shell-bestand worden gegenereerd.',
      failed: 'Het ophalen van het shell-bestand is mislukt.',
    },
  },
  stlDownload: {
    buttonSingular: {
      title: '3D-bestand downloaden',
    },
    buttonMultiple: {
      title: '3D-bestanden downloaden',
    },
    buttonMultipleOrSingular: {
      title: '3D-bestand(en) downloaden',
    },
    buttonGenerating: {
      title: '3D-bestand genereren',
    },
    buttonGeneratingMultiple: {
      title: '3D-bestand(en) genereren',
    },
    notification: {
      success: 'De 3D-bestanden zijn succesvol gedownload!',
    },
  },
  demo: {
    form: {
      title: 'Orthosolid Demo',
      email: 'E-mail addres',
      name: 'Volledige naam',
      company: 'Bedrijf',
      carpi: 'Orthosolid Carpi Demo',
      mino: 'Orthosolid Mino Demo',
      volar: 'Orthosolid Volar Demo',
    },
    reset: 'Reset',
    contactForm: {
      title: 'Contactformulier',
      field: 'Tekst',
      placeholder: 'Voer uw bericht aan Orthobroker in.',
    },
  },
  marketingWebsite: {
    contact: {
      form: {
        name: 'Naam',
        company: 'Bedrijf',
        email: 'E-mailadres',
        message: 'Bericht',
        submit: 'Verzenden',
        value: 'Waarde',
        success: 'Bedankt voor uw contact met OrthoSolid. Wij nemen spoedig contact met u op.',
        error:
          'Er is iets misgegaan bij het verwerken van uw bericht. Wij raden u aan om ons rechtstreeks een e-mail te sturen naar info@orthobroker.com.',
        recaptchaError: 'Vul de reCAPTCHA in.',
      },
    },
  },
  notificationTypes: {
    creditsLow: 'Laag creditsaldo',
    creditsRequested: 'Creditaanvragen',
    orderPlaced: 'Bestelling geplaatst',
    orderInProcess: 'Bestelling in verwerking',
    orderDelayed: 'Bestelling vertraagd',
    orderShipped: 'Bestelling afgerond',
    orderInvoiced: 'Bestelling gefactureerd',
    reactionsFromSupport: 'Reacties van support',
    platformUpdates: 'Platformupdates',
    newsletter: 'Nieuwsbrief',
  },
  insights: {
    useCases: 'Toepassingen',
    guides: 'Handleidingen',
    webinars: 'Webinars',
    comparisons: 'Vergelijkingen',
  },
  website: {
    menu: 'Menu',
  },
  addToCart: {
    errors: {
      noInput: 'Er lijkt geen product te zijn geselecteerd. Probeer het nog eens met een product.',
      notReadyToOrder: 'Dit product kan nog niet worden besteld. Pas het aan voordat je bestelt.',
      addingToCart:
        'Er is een fout opgetreden bij het toevoegen van het product aan het winkelmandje. Neem contact op met de klantenservice.',
    },
  },
  credits: {
    checkout: {
      title: 'Credits',
      cost: 'Deze bestelling kost',
      balance: 'Jouw saldo',
      after: 'Saldo na deze bestelling',
      amount: '{credits} credits',
      amountOne: '1 credit',
      alreadyPaid: 'Al betaald',
      unknownCost: 'Prijs onbekend',
      shortfall: 'Je hebt {credits} credits meer nodig om deze bestelling te plaatsen.',
      shortfallOne: 'Je hebt 1 credit meer nodig om deze bestelling te plaatsen.',
      buy: 'Credits kopen',
      requestMore: 'Meer credits aanvragen',
      unpriced:
        'Een of meer digitale producten in deze bestelling hebben nog geen creditprijs. Neem contact op met Orthobroker voordat je bestelt.',
      covered: 'Je saldo dekt deze bestelling.',
    },
    cart: {
      blocked:
        'Je hebt niet genoeg credits voor dit product. Je hebt {credits} credits meer nodig.',
      blockedOne: 'Je hebt niet genoeg credits voor dit product. Je hebt 1 credit meer nodig.',
      blockedUnpriced:
        'Dit product heeft nog geen creditprijs. Neem contact op met Orthobroker voordat je het toevoegt.',
    },
    request: {
      sent: 'Je aanvraag is verstuurd naar de beheerders van je organisatie.',
      sentShort: 'Aanvraag verstuurd',
      noAdmins:
        'Je organisatie heeft geen beheerder om deze aanvraag naartoe te sturen. Neem contact op met Orthobroker.',
      failed: 'We konden je aanvraag niet versturen. Probeer het opnieuw.',
    },
    available: 'Beschikbare credits',
    topUp: 'Opwaarderen',
    requestMore: 'Meer credits aanvragen',
    requestMoreHint: 'Vraag een beheerder van uw bedrijf om credits op te waarderen.',
    expiry: '{amount} credits vervallen op {date}',
    expiryOne: '1 credit vervalt op {date}',
    printsLeft: 'Nog {prints} prints',
    printsLeftOne: 'Nog 1 print',
    noPacks: 'Er zijn op dit moment geen creditpakketten beschikbaar.',
    loadError: 'Uw credits konden niet worden geladen. Probeer het opnieuw.',
    currency: {
      label: 'Valuta wijzigen:',
      note: 'Prijzen in andere valuta dan EUR zijn indicatief.',
    },
    orderStatus: {
      requested: 'Aangevraagd',
      confirmed: 'Bevestigd',
      cancelled: 'Geannuleerd',
    },
    table: {
      distributor: 'Distributeur',
      credits: 'Credits',
      price: 'Prijs',
      pack: 'Pakket',
      requestedBy: 'Aangevraagd door',
      requestedAt: 'Aangevraagd op',
      confirmedAt: 'Bevestigd op',
    },
    pack: {
      save: 'Bespaar {amount}',
      prints: '{prints} prints',
      printsOne: '1 print',
      add: 'Toevoegen',
      addHint: 'Vraag dit pakket aan. Orthobroker factureert het en voegt de credits toe.',
      expiry: 'Credits die vandaag worden gekocht, vervallen op {date}',
      requested: 'Aangevraagd',
      requestSuccessTitle: 'Aanvraag verzonden',
      requestSuccess:
        'We hebben uw aanvraag voor {credits} credits ontvangen. Orthobroker factureert deze en de credits worden toegevoegd zodra de betaling is bevestigd.',
      requestNotAllowed: 'De beheerder van uw bedrijf moet credits aanvragen voor uw organisatie.',
      requestUnavailable: 'Dit pakket is momenteel niet beschikbaar voor uw bedrijf.',
      rateUnavailable: 'Weergegeven in euro: de {currency}-koers is momenteel niet beschikbaar.',
      requestFailed: 'We konden uw aanvraag niet verzenden. Probeer het opnieuw.',
    },
    categories: {
      carpi: 'Carpi',
      mino: 'Mino',
      volar: 'Volar',
    },
    faq: {
      title: 'Over credits',
      q1: 'Wat zijn credits?',
      a1: 'Met credits koopt u digitale bestanden die u zelf in huis kunt 3D-printen.',
      q2: 'Vallen producten die door Orthobroker geproduceerd worden onder het creditsysteem?',
      a2: 'Nee. Producten die Orthobroker produceert en levert, worden apart gefactureerd.',
      q3: 'Kunnen credits binnen mijn organisatie gedeeld worden?',
      a3: 'Ja. Credits worden gedeeld binnen uw hele organisatie en kunnen door alle professionals worden gebruikt.',
      q4: 'Vervallen credits?',
      a4: 'Ja. Alle credits vervallen {months} maanden na de aankoopdatum.',
      q5: 'Hoeveel credits kost een digitaal bestand?',
      a5: 'Het aantal benodigde credits hangt af van het specifieke product en wordt vóór de aankoop getoond.',
    },
  },
  decisionFlows: {
    title: 'Beslisstromen voor producten',
    description: 'Bouw zonder code de vragenlijst die een product en de startparameters kiest.',
    loading: 'Stromen laden',
    saving: 'Opslaan…',
    flow: 'Stroom',
    untitled: 'Zonder titel',
    reorder:
      '{name} verplaatsen: sleep het, gebruik de pijltjestoetsen of open het om het omhoog of omlaag te zetten',
    moveUp: 'Omhoog',
    moveDown: 'Omlaag',
    tabs: {
      questions: 'Vragen',
      outcomes: 'Eindresultaten',
      credits: 'Creditsysteem',
      simulator: 'Uitproberen',
    },
    credits: {
      intro:
        'Bepaal wanneer een product dat met deze flow is gemaakt credits van het account van de klant verbruikt. De regel wordt gecontroleerd wanneer het product wordt besteld.',
      match: 'Credits verbruiken wanneer',
      matches: {
        all: 'Alle voorwaarden kloppen (EN)',
        any: 'Eén voorwaarde klopt (OF)',
      },
      legend: 'Voorwaarden',
      noQuestions:
        'Geen enkele vraag slaat haar antwoord op in de productconfiguratie, dus geen enkele kan over credits beslissen.',
      unpriced:
        'Deze categorie heeft geen creditprijs, dus de checkout weigert elk product dat de regel selecteert.',
      fallback:
        'Geen voorwaarden: de ingebouwde regel geldt, en alleen producten die de klant zelf produceert verbruiken credits.',
    },
    toolbar: {
      importJson: 'JSON importeren',
      exportJson: 'JSON exporteren',
      imported: '{title} geïmporteerd',
      exported: '{file} geëxporteerd',
      fileTooLarge: 'Het bestand is groter dan {size}.',
      hideList: 'Lijst verbergen',
      showList: 'Lijst tonen',
    },
    flows: {
      none: 'Er zijn nog geen stromen. Maak de eerste om te beginnen.',
      create: 'Nieuwe stroom',
      createTitle: 'Nieuwe stroom',
      settingsTitle: 'Instellingen van de stroom',
      name: 'Naam van de stroom',
      category: 'Productcategorie',
      categoryHint: 'Bepaalt uit welke producten deze stroom kan kiezen.',
      noCategory: 'Geen categorie',
      saveSettings: 'Instellingen opslaan',
      duplicateTitle: 'Stroom dupliceren',
      duplicate: 'Kopie maken',
      copyName: '{title} (kopie)',
      live: 'Gebruiken bij het maken van producten',
      liveHint:
        'Het maken van producten in deze categorie volgt deze stroom. Inschakelen schakelt elke andere stroom van de categorie uit.',
      liveNeedsCategory:
        'Kies eerst een productcategorie: de stroom begeleidt het maken van producten in die categorie.',
      liveWithIssues:
        'Deze stroom heeft {count} problemen. Het maken van producten stopt waar zij een gat laten.',
      liveTag: 'bij het maken van producten',
      cancel: 'Annuleren',
      delete: 'Stroom verwijderen',
      more: 'Meer acties voor de stroom',
    },
    deleteFlow: {
      title: 'Deze stroom verwijderen?',
      body: '{title} wordt met de vragen en eindresultaten verwijderd. Dit kan niet ongedaan worden gemaakt.',
      confirm: 'Stroom verwijderen',
    },
    confirmDelete: {
      confirm: 'Verwijderen',
      cancel: 'Annuleren',
      title: '{name} verwijderen?',
      conditionTitle: 'De voorwaarde op {question} verwijderen?',
      combinationTitle: 'Combinatie {number} verwijderen?',
      question:
        'De antwoorden gaan mee, en de voorwaarden en combinaties die de vraag lezen, vergeten haar. Dit kan niet ongedaan worden gemaakt.',
      answer:
        'De voorwaarden en combinaties die dit antwoord kiezen, vergeten het. Dit kan niet ongedaan worden gemaakt.',
      condition:
        'Zonder deze voorwaarde hangt dit niet meer van die vraag af. Dit kan niet ongedaan worden gemaakt.',
      parameter: 'Deze waarde wordt niet meer ingesteld. Dit kan niet ongedaan worden gemaakt.',
      dialog:
        'Het dialoogvenster en de keuzes worden verwijderd. Dit kan niet ongedaan worden gemaakt.',
      choice: 'De keuze en de parameters worden verwijderd. Dit kan niet ongedaan worden gemaakt.',
      combination:
        'Deze antwoorden kiezen het product niet meer. De productconfiguratie zelf blijft bestaan. Dit kan niet ongedaan worden gemaakt.',
    },
    stepTypes: {
      decisionQuestion: 'Vraag',
    },
    fields: {
      target: 'Geldt voor',
      targets: {
        shapediver: '3D-model',
        product: 'Product',
      },
      numberRequired: 'Voer een getal in',
      translate: 'Vertalen vanuit het Engels',
      translations: 'Vertalingen ({filled}/{total})',
      translateFailed: 'Er is niets vertaald. Probeer het zo opnieuw.',
      linked: 'Gedeeld met de productwizard: een wijziging hier verschijnt daar ook',
      linkedNameKept: 'Een naam is verplicht — de opgeslagen naam blijft tot je een nieuwe typt',
      translated: 'Vertaald naar {count} talen',
      markdown: {
        bold: 'Vet',
        italic: 'Cursief',
        heading: 'Kop',
        bulletList: 'Opsommingslijst',
        orderedList: 'Genummerde lijst',
      },
      pick: 'Kies een veld…',
      unknown: '{name} (geen parameter van het 3D-model)',
      unknownError:
        '{name} is geen parameter van de 3D-modellen van de {category}-producten die deze flow kan maken. Kies er een uit de lijst.',
      modelHint:
        'Uit de 3D-modellen van de {category}-producten die deze flow kan maken. Een naam die niet elk product heeft, vermeldt welke producten hem hebben.',
      modelEmpty:
        'De producten van {category} hebben nog geen gesynchroniseerde ShapeDiver-sessie, dus er zijn geen parameters om te kiezen.',
      misspelled: 'Anders gespeld in andere modellen',
      spellingWarning:
        'Andere 3D-modellen spellen deze parameter {spellings}. Een waarde bereikt alleen de modellen die hem precies zo spellen: hernoem de parameter in ShapeDiver zodat alle modellen overeenkomen.',
      noCategory:
        'Geef deze flow eerst een categorie: de 3D-modellen van haar producten zijn wat je hier kunt kiezen.',
    },
    questions: {
      empty: 'Deze stroom heeft nog geen vragen. Voeg hieronder de eerste toe.',
      count: 'Vragen: {count}',
      addQuestion: 'Vraag toevoegen',
      questionTitle: 'Vraag',
      instructions: 'Tekst van de groene kaart',
      instructionsHint: 'Markdown die onder de vraag in de productwizard staat',
      answerField: 'Configuratorparameter',
      answerFieldHint:
        'Elk antwoord geeft deze parameter van het 3D-model zijn waarde. Leeg gelaten stelt de vraag niets in de configurator in.',
      disabled: 'Uitgeschakeld',
      disabledDescription:
        'Toegepast in het dialoogvenster om een product naar een andere configuratie te dupliceren',
      decidedValue: 'Waarde van {field}',
      setDecidedValue: '{field} instellen',
      clearDecidedValue: 'Waarde van {field} wissen',
      answerCount: '{count} antwoorden',
      options: 'Antwoorden',
      optionLabel: 'Antwoord',
      addOption: 'Antwoord toevoegen',
      olderParameters:
        'Stelt ook {values} in, van vóór de antwoorden hun parameterlijst kwijtraakten.',
      removeOlderParameters: 'Verwijderen',
      removeOption: 'Antwoord {name} verwijderen',
      deleteStep: '{name} verwijderen',
      parameterName: 'Slaat op in',
      min: 'Minimum',
      max: 'Maximum',
      step: 'Stapgrootte',
      unit: 'Eenheid',
      defaultValue: 'Standaardwaarde',
    },
    conditions: {
      stepLegend: 'Alleen vragen als',
      optionLegend: 'Alleen tonen als',
      question: 'Vraag',
      answers: 'Antwoorden',
      add: 'Voorwaarde toevoegen',
      remove: 'Voorwaarde op {question} verwijderen',
      pickAnswers: 'Kies minstens één antwoord',
    },
    dialogs: {
      add: 'Dialoogvenster toevoegen',
      count: 'Dialoogvensters',
      dialogTitle: 'Titel van het dialoogvenster',
      description: 'Beschrijving',
      control: 'Besturingselement',
      controls: {
        single: 'Eén keuze',
        multi: 'Meerdere keuzes',
        number: 'Getal',
        text: 'Tekst',
      },
      optional: 'Optioneel',
      showOnOutcome: 'Tonen op de kaart van het eindresultaat',
      choiceLabel: 'Keuze',
      addChoice: 'Keuze toevoegen',
      skip: 'Overslaan',
      removeChoice: 'Keuze {name} verwijderen',
      remove: 'Dialoogvenster {name} verwijderen',
      value: 'Waarde',
    },
    outcomes: {
      addRow: 'Combinatie toevoegen',
      overview: 'Tekst van het overzicht',
      overviewHint:
        'Markdown op de groene kaart van de laatste wizardstap, Overzicht. Blijft het veld leeg, dan verschijnt de standaardtekst.',
      addMissing: 'Ontbrekende combinaties toevoegen',
      missingTitle: 'Ontbrekende combinaties: {count}',
      addMissingRow: 'Combinatie toevoegen',
      addMissingRowFor: 'Combinatie toevoegen voor {answers}',
      missingMore:
        'Nog {count} worden niet getoond. "Ontbrekende combinaties toevoegen" voegt ze allemaal toe.',
      anyAnswer: 'Elk antwoord',
      rowCount: 'Combinaties: {count}',
      hint: 'Kies elk antwoord dat een combinatie dekt. Antwoorden die haar andere vakjes uitsluiten zijn grijs, en een vraag die ze nooit stelt blijft leeg.',
      table: 'Tabel met eindresultaten',
      actions: 'Acties',
      any: 'Elk antwoord',
      choose: 'Kiezen…',
      notAsked: 'Niet gevraagd',
      name: 'Naam',
      image: 'Afbeelding',
      answerCell: '{question}, combinatie {number}',
      openDetails: 'Details van combinatie {number}',
      deleteRow: 'Combinatie {number} verwijderen',
      details: 'Combinatie {number}',
      productTemplate: 'Productworkflow',
      productHint:
        'Bij het opslaan van de combinatie ontstaat een eigen productconfiguratie met naam, workflow, afbeelding en antwoorden.',
      linkedHint:
        'Wijzigingen worden toegepast wanneer u de combinatie opslaat. Een product dat een andere flow of categorie gebruikt, krijgt een eigen kopie.',
      discard: 'Verwerpen',
      saveRow: 'Combinatie {number} opslaan',
      saved: 'Combinatie {number} opgeslagen',
      close: 'Sluiten',
      product: 'Product',
      imageUpload: 'Afbeelding uploaden',
      imageReplace: 'Afbeelding vervangen',
      imageUploading: 'Uploaden…',
      imagePending: 'Wordt opgeslagen met de combinatie',
      imageNeedsSave:
        'Sla eerst de combinatie op: de afbeelding hoort bij het product dat ze maakt.',
      imageFailed: 'De afbeelding kon niet worden geüpload. Probeer het opnieuw.',
      imageBrowse: 'Bekijk de afbeelding in de galerij',
    },
    parameters: {
      title: 'Parameters',
      name: 'Veld',
      remove: 'Parameter {name} verwijderen',
      valueType: 'Waardetype',
      reservedName: 'Deze naam is gereserveerd, kies een andere.',
      valueTypes: {
        decisionParameterNumber: 'Getal',
        decisionParameterBoolean: 'Ja / nee',
        decisionParameterString: 'Tekst',
      },
      value: 'Waarde',
      add: 'Parameter toevoegen',
      help: 'Waarden die worden ingesteld zodra het geldt, elk voor een parameter van het 3D-model of een productveld. Bestemming en type van de waarde volgen het veld.',
      pickOption: 'Kies een optie…',
      unsynced:
        'Synchroniseer de ShapeDiver-sessie van deze parameter om uit zijn opties te kiezen.',
      true: 'Waar',
      false: 'Onwaar',
    },
    simulator: {
      title: 'Probeer de vragenlijst',
      restart: 'Opnieuw beginnen',
      change: 'Wijzigen',
      changeAnswer: 'Wijzigen: antwoord op {question}',
      valueHint: 'Tussen {min} en {max}',
      outOfRange: 'Voer een waarde tussen {min} en {max} in',
      result: 'Gekozen product',
      shapediverParameters: 'Instellingen van het 3D-model',
      productParameters: 'Productparameters',
      noParameters: 'Geen',
      invalid: 'De vragenlijst kan niet verder:',
    },
    issues: {
      none: 'Geen problemen gevonden',
      count: 'Problemen: {count}',
      emptyQuestion: 'Deze vraag heeft geen antwoorden.',
      emptyFlow: 'De stroom heeft geen stappen.',
      unknownCondition: 'Een voorwaarde leest een vraag die niet in de stroom staat.',
      forwardCondition: 'Een voorwaarde leest een vraag die later wordt gesteld.',
      resultWithoutProduct: 'Deze combinatie heeft geen product.',
      unknownAnswer:
        'Een voorwaarde of combinatie verwijst naar een antwoord dat niet meer bestaat.',
      unreachableResult:
        'Een specifiekere combinatie wint altijd van deze, dus deze wordt nooit gebruikt.',
      conflictingResults: 'Een andere combinatie is even specifiek voor dezelfde antwoorden.',
      impossibleResult:
        'Deze antwoorden kunnen nooit samen gegeven worden, dus deze combinatie wordt nooit gebruikt.',
      unansweredCell: 'Kies de antwoorden die deze combinatie dekt voor elke vraag die ze stelt.',
      impossibleAnswer:
        'Een hier gekozen antwoord kan nooit samengaan met de andere antwoorden van deze combinatie.',
      duplicateResult: 'Een andere combinatie heeft precies dezelfde antwoorden.',
      missingResult: 'Sommige combinaties van antwoorden leiden naar geen enkel product.',
      tooManyCombinations:
        'Deze flow heeft te veel antwoordcombinaties om volledig te controleren.',
      emptyDialog:
        'Dit dialoogvenster vraagt niets: het heeft geen keuzes en geen parameter om in te vullen.',
      invalidDialogBounds: 'Het minimum ligt boven het maximum, of de stap is niet groter dan nul.',
      undeclaredAnswerField:
        'Deze vraag stelt een configuratorparameter in die de 3D-modellen die deze flow kan maken niet hebben.',
      unknownProductField:
        'Dit antwoord zet een productwaarde die geen productveld is, dus nieuwe producten laten hem vallen. Stuur hem in plaats daarvan naar het 3D-model.',
      invalidCreditCondition:
        'Een creditvoorwaarde heeft geen antwoorden, of leest een vraag waarvan het antwoord niet op het product wordt opgeslagen, dus bestellingen negeren haar.',
    },
    parseErrors: {
      invalidJson: 'Het bestand is geen geldige JSON.',
      notAFlow: 'Het bestand is geen beslisstroom voor producten.',
      invalidStep: 'Een stap is ongeldig ({path}).',
      invalidOption: 'Een antwoord is ongeldig ({path}).',
      invalidParameter: 'Een parameter is ongeldig ({path}).',
      invalidResult: 'Een combinatie is niet geldig ({path}).',
      invalidCondition: 'Een voorwaarde is ongeldig ({path}).',
      invalidDialog: 'Een dialoogvenster is ongeldig ({path}).',
      invalidAnswerField: 'Een vraagveld is ongeldig ({path}).',
      duplicateKey: 'Twee items delen dezelfde sleutel ({path}).',
      unknownField: 'Het bestand bevat een veld dat het stroomformaat niet kent ({path}).',
      tooLarge: 'De stroom heeft te veel onderdelen om te openen ({path}).',
    },
    storage: {
      'not-allowed':
        'Sanity heeft deze actie geweigerd. Controleer of je bent ingelogd en je rol dit toestaat.',
      otherDataset: 'Beslisstromen worden alleen in de werkruimte {dataset} bewerkt.',
      openDataset: 'Editor voor {dataset} openen',
      linkedFailed:
        'Een gedeelde tekst kon niet worden opgeslagen. Laad dit tabblad opnieuw om de opgeslagen versie te zien.',
      'not-found': 'Die stroom bestaat niet meer.',
      dropped: 'Onleesbare stromen zijn overgeslagen: {count}.',
      invalid: 'De wijzigingen konden niet worden opgeslagen omdat de stroom ongeldig is.',
      failed: 'De wijzigingen konden niet worden opgeslagen. Probeer het opnieuw.',
    },
  },
};

export default nl;
